import { render, staticRenderFns } from "./joinSDKNotice.vue?vue&type=template&id=9900d882&scoped=true"
import script from "./joinSDKNotice.vue?vue&type=script&lang=js"
export * from "./joinSDKNotice.vue?vue&type=script&lang=js"
import style0 from "./joinSDKNotice.vue?vue&type=style&index=0&id=9900d882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9900d882",
  null
  
)

export default component.exports